// extracted by mini-css-extract-plugin
module.exports = {"timeLabel":"_32bbee5fda--timeLabel--JEeWO","relative":"_32bbee5fda--relative--Cj7Uc","absolute":"_32bbee5fda--absolute--LJ3Qn"};